<!--
 * @Author: linwl 1015547748@qq.com
 * @Date: 2020-12-07 14:27:17
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-02 15:14:28
 * @FilePath: \newmall\src\components\Tabbar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <van-tabbar
    route
    :active-color="iconActiveColor"
    :inactive-color="inactiveColor"
    class="tabbar"
  >
    <van-tabbar-item
      v-for="(item, index) of tabList"
      :key="index"
      replace
      :to="item.path"
      :name="index"
    >
      <span>{{ item.name }}</span>
      <!-- #icon="props" -->
      <template #icon="props">
        <svg-icon
          class="icons"
          :iconClass="item.icon"
          :style="{
            color: props.active
              ? activeColor
              : inactiveColor
          }"
        ></svg-icon>
      </template>
      <!-- <template #icon="props">
       <div class="tabbar-icon-text" :style="{color: props.active ? iconActiveColor : inactiveColor}">{{ item.icon }}</div>
      </template> -->
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
// import tabbar from '@/router/routes/tabbarRoute.js'
import iconManager from '@/utils/iconManager'

export default {
  props: {
    activeColor: {
      type: String,
      default: '' // #913939
    },
    inactiveColor: {
      type: String,
      default: '#000000' // #d35353
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    iconActiveColor() {
      return (
        this.activeColor || this.$colorConfig.primaryColor
      )
    }
  },
  data() {
    return {
      active: 0,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true
    }
  },
  methods: {
    renderIcon(iconName) {
      return `../assets/icons/${iconName}.png`
    }
  },
  mounted() {
    window.onresize = () => {
      if (
        this.clientHeight >
        document.documentElement.clientHeight
      ) {
        this.showBtn = false
      } else {
        this.showBtn = true
      }
    }
    
    // 预加载所有Tabbar图标以确保流畅体验
    // if (this.tabList && this.tabList.length > 0) {
    //   const tabIcons = this.tabList.map(item => item.icon)
    //   iconManager.preloadIcons(tabIcons).catch(error => {
    //     console.warn('Failed to preload tabbar icons:', error)
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
.van-tabbar {
  height: 1rem;
}

.van-tabbar-item--active {
  background: none;
  // color: #FFBE0D !important;
}

.tabbar {
  // background: $primary-color;
  // background: url('~@/assets/Tabbar/tabbar-bg.png') no-repeat 50%/100%;
}

.tabbar-icon-text {
  font-size: 0.36rem;
  font-family: 'system-ui';
  font-weight: 600;
  color: #fff;
  margin-bottom: 5px;
}
// .icons {
//   width: 0.6rem;
//   height: 0.6rem;
// }

.tabble-name {
  color: #cf7d4a;
}
</style>